module.exports = __webpack_public_path__ + "static/FSG-2782cc61c1ecfb103a1064762c9c079e.jpg";